
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic10On as ObiHydraulic10OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-10-on.js';
 
 
 

 
 export const ObiHydraulic10On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-10-on',
   elementClass: ObiHydraulic10OnElement,
   events: {
     
   }
  });
 
 